import React from 'react';
import Menu from '../components/Menu/Menu';

const MenuPage = () => {
  return (
    <div style={{ marginTop: '151px' }}>
      <Menu />
    </div>
  );
};

export default MenuPage;
